import { Pill } from '@eleveo/components-react';
import { CheckmarkIcon, DangerIcon, WarningIcon } from '@eleveo/icons-react';
import { TFunction } from 'i18next';
import React from 'react';

import { ETL_CONFIGURATION_STATUS, Values } from '../components/configuration/types';

export const getPillConfig = (status: Values<typeof ETL_CONFIGURATION_STATUS> | undefined, t: TFunction) => {
  if (!status) {
    return undefined;
  }

  let color: React.ComponentProps<typeof Pill>['color'] = 'success';
  let variant: React.ComponentProps<typeof Pill>['variant'] = 'outline';
  let icon: JSX.Element = <CheckmarkIcon />;

  if (status === ETL_CONFIGURATION_STATUS.unauthorized || status === ETL_CONFIGURATION_STATUS.error) {
    color = 'error';
    variant = 'solid';
    icon = <DangerIcon />;
  }

  if (status === ETL_CONFIGURATION_STATUS.inactive) {
    color = 'warning';
    variant = 'solid';
    icon = <WarningIcon />;
  }

  return {
    color,
    variant,
    icon,
    statusText: t(`configuration.statuses.${status.toLowerCase()}`),
  };
};
